/**
 * Created by Bob.Gear on 3/05/14.
 */
//------------------------------------------------------------------------
//  pipelineFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('pipelinesFilterController', ['$scope', 'lookupTables',
      function ($scope, lookupTables) {
        $scope.componentName = "pipelinesFilter";

        $scope.pipelineMaterials = lookupTables.pipelineMaterials();
        //  $scope.equipmentTypes = [];



        $scope.resetFilter = function () {
          $scope.clearPipelineSelections();
        };

        $scope.clearPipelineSelections = function () {
          $scope.criteria.selectedMaterials = null;
          delete $scope.criteria["selectedMaterials"];

          $scope.criteria.diameterFrom = null;
          delete $scope.criteria["diameterFrom"];

          $scope.criteria.diameterTo = null;
          delete $scope.criteria["diameterTo"];
        };

        $scope.removePipelinesFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#pipelinesFilter");
        };

        $scope.showInvalidMessage = function () {

          // bail if the form does not exist
          if(!$scope.pipelinesFilterForm) return false;

          // reset the diameter field validity before we start
          $scope.pipelinesFilterForm.txtDiameterFrom.$setValidity("$valid", true);
          $scope.pipelinesFilterForm.txtDiameterTo.$setValidity("$valid", true);

          var showMessage = ($scope.pipelinesFilterForm.$invalid && $scope.pipelinesFilterForm.$dirty);

          if (angular.isNumber($scope.criteria.diameterFrom)
              && angular.isNumber($scope.criteria.diameterTo)
              && ($scope.criteria.diameterFrom >= $scope.criteria.diameterTo)) {
            showMessage = true;

            $scope.pipelinesFilterForm.txtDiameterFrom.$setValidity("$valid", false);
            $scope.pipelinesFilterForm.txtDiameterTo.$setValidity("$valid", false);
          }

          // overriding condition that trumps all others
          if ($scope.pipelinesFilterForm.$pristine) showMessage = false;

          return showMessage;
        };


        $scope.initialiseFilter =  function(){
          $scope.pipelineMaterials = lookupTables.pipelineMaterials();

          //$scope.criteria.isPipelineOffshore = true;
          //$scope.criteria.isPipelineOnshore = true;

        };

        $scope.$watch("criteria.isPipelineOffshore", function(newval){
          if(!newval && !$scope.criteria.isPipelineOnshore)
            $scope.criteria.isPipelineOnshore = true;
        });

        $scope.$watch("criteria.isPipelineOnshore", function (newval) {
          if (!newval && !$scope.criteria.isPipelineOffshore)
            $scope.criteria.isPipelineOffshore = true;
        });

        $scope.$watch("criteria.selectedMaterials.length", function () {
          if (!$scope.criteria.selectedMaterials) return;

          $scope.selectedCount = $scope.criteria.selectedMaterials.length;
          $scope.plural = ($scope.selectedCount === 1) ? "" : "s";
        });

        $scope.initialiseFilter();
      }])
    .directive('pipelinesFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/pipelinesFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'pipelinesFilterController'
        };
      }]);
//------------------------------------------------------------------------
